<template>
  <div class="AddServiceContract">
    <div class="tabWrap">
      <div class="approve-rule">
        <span @click="SeeApproveRule">查看合同审批制度</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="120px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同分类" prop="type">
                    <el-select
                      v-model="dialogForm.type"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      :disabled="true"
                    >
                      <el-option label="劳务合同" value="LABOR"></el-option>
                      <el-option label="机械合同" value="MACHINE"></el-option>
                      <el-option label="材料合同" value="MATERIAL"></el-option>
                      <el-option label="其它" value="OTHERS"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同编号" prop="serialNumber">
                    <el-input v-model="dialogForm.serialNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同名称" prop="name">
                    <el-input v-model="dialogForm.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同内容" prop="content">
                    <el-input v-model="dialogForm.content"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="我方单位" prop="partyAId">
                    <el-select
                      v-model="dialogForm.partyAId"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="ContractPartAChange"
                    >
                      <el-option
                        :label="supplier.companyName"
                        :value="supplier.id"
                        v-for="supplier in SupplierAList"
                        :key="supplier.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主要相对方单位" prop="partyBId">
                    <el-select
                      v-model="dialogForm.partyBId"
                      filterable
                      placeholder="请选择"
                      @change="ContractPartBChange"
                    >
                      <el-option
                        :label="supplier.companyName"
                        :value="supplier.id"
                        v-for="supplier in SupplierList"
                        :key="supplier.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="其他相对方">
                    <el-select
                      v-model="otherPartyBIds"
                      filterable
                      multiple
                      placeholder="请选择"
                    >
                      <el-option
                        :label="supplier.companyName"
                        :value="supplier.id"
                        v-for="supplier in SupplierList"
                        :key="supplier.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所属项目" prop="projectId">
                    <el-select
                      v-model="dialogForm.projectId"
                      placeholder="-请选择-"
                      filterable
                      default-first-option
                      @change="handleProjectChange"
                    >
                      <el-option
                        :label="item.name"
                        :value="item.id + ''"
                        v-for="(item, index) in ProjectNameList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="签订日期">
                    <el-date-picker
                      v-model="dialogForm.signDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同金额" prop="amount">
                    <el-input
                      v-model="dialogForm.amount"
                      @keyup.native="checkAmount(1)"
                      @blur="Fornmat(1)"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input v-model="dialogForm.amountShow"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="不含税价" prop="amountWithoutTax">
                    <el-input
                      v-model="dialogForm.amountWithoutTax"
                      @keyup.native="checkAmount(2)"
                      @blur="Fornmat(2)"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input v-model="dialogForm.amountWithoutTaxShow"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="税率" prop="taxRate">
                    <el-input
                      v-model="dialogForm.taxRate"
                      @keyup.native="checkValue(1)"
                    >
                      <i slot="suffix">%</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税金" prop="amountTax">
                    <el-input
                      v-model="dialogForm.amountTax"
                      @keyup.native="checkAmount(3)"
                      @blur="Fornmat(3)"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input v-model="dialogForm.amountTaxShow"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同期限" prop="contractPeriodArr">
                    <el-date-picker
                      v-model="dialogForm.contractPeriodArr"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    >
                    </el-date-picker>
                    <!-- <el-date-picker
                      v-model="dialogForm.contractPeriod"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同份数" prop="copies">
                    <el-input
                      v-model="dialogForm.copies"
                      :onkeyup="
                        (dialogForm.copies = (dialogForm.copies + '').replace(
                          /[^\d]/g,
                          ''
                        ))
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式" prop="purchaseType">
                    <el-select
                      v-model="dialogForm.purchaseType"
                      filterable
                      default-first-option
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in typeOption"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      ></el-option>
                      <!-- <el-option label="直接采购" value="DIRECT"></el-option> -->
                      <!-- <el-option label="议标" value="NEGOTIATION"></el-option> -->
                      <!-- <el-option
                        label="公开招标"
                        value="OPEN_TENDER"
                      ></el-option>
                      <el-option label="询价采购" value="INQUIRY"></el-option>
                      <el-option
                        label="单一来源采购"
                        value="SINGLE_SOURCE"
                      ></el-option>
                      <el-option label="邀请招标" value="INVITE"></el-option>
                      <el-option
                        label="竞争性谈判"
                        value="COMPETITIVE_NEGOTIATION"
                      ></el-option>
                      <el-option
                        label="竞争性磋商"
                        value="COMPETITIVE_CONSULT"
                      ></el-option> -->
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同重要约定" prop="agreeOn">
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      v-model="dialogForm.agreeOn"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col style="padding-left: 110px" :span="8">
                      <el-checkbox
                        v-model="checkedone"
                        style="width: 100px"
                        label="1"
                        @change="handleCheckChange"
                        >是否预付款？</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预付款比例" prop="advancePayPct">
                        <el-input
                          v-model="dialogForm.advancePayPct"
                          :disabled="!checkedone"
                          @keyup.native="checkValue(2)"
                        >
                          <i slot="suffix">%</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="付款比例" prop="advancePayPctAct">
                        <el-input
                          v-model="dialogForm.advancePayPctAct"
                          :disabled="!checkedone"
                          @keyup.native="checkValue(3)"
                        >
                          <i slot="suffix">%</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding-left: 110px" :span="8">
                      <el-checkbox
                        v-model="checkedtwo"
                        style="width: 100px"
                        label="1"
                        @change="handleCheckChange"
                        >单价合同</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预估合同金额" prop="predictPrice">
                        <el-input
                          v-model="dialogForm.predictPrice"
                          :disabled="!checkedtwo"
                          @keyup.native="checkAmount(11)"
                          @blur="Fornmat(11)"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预估合同数量" prop="predictAmount">
                        <el-input
                          v-model="dialogForm.predictAmount"
                          :disabled="!checkedtwo"
                          :onkeyup="
                            (dialogForm.predictAmount = (
                              dialogForm.predictAmount + ''
                            ).replace(/[^0-9]/gi, ''))
                          "
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding-left: 110px" :span="8">
                      <el-checkbox
                        v-model="checkedthree"
                        style="width: 100px"
                        label="0"
                        @change="handleCheckChange3"
                        >总价合同</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="合同金额" prop="totalAmount">
                        <el-input
                          v-model="dialogForm.totalAmount"
                          :disabled="!checkedthree"
                          @keyup.native="checkAmount(12)"
                          @blur="Fornmat(12)"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="dialogForm.comments"
                      maxlength="566"
                      size="medium"
                      style="width: 100%; min-width: 566px"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人" prop="applyUserName">
                    <el-input
                      v-model="dialogForm.applyUserName"
                      readonly
                    ></el-input>
                    <!-- <el-input
                      v-model="dialogForm.applyUserName"
                      :editable="false"
                      @focus="ShowApplyUserDia"
                    ></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门">
                    <el-input
                      v-model="dialogForm.applyDeptName"
                      readonly
                    ></el-input>
                    <!-- <el-cascader
                      ref="cascaderAddr"
                      v-model="dialogForm.applyDeptId"
                      :options="subDeptList"
                      :props="defaultProps"
                      @change="handleChange"
                      :placeholder="dialogForm.applyDeptName"
                      @active-item-change="handleChange"
                      change-on-select
                    ></el-cascader> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="editFlag">
                <el-col :span="6">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="内部定额表"
          name="second"
          style="text-align: left"
          class="firstTab1"
          v-if="dialogForm.type == 'LABOR'"
        >
          <itemList
            @saveUnionItems="saveUnionItems"
            :contractType="dialogForm.type"
            @setDecimalShow="setDecimalShow"
            :engineerItems="dialogForm.subContractUnionDetailsVOList"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></itemList>
        </el-tab-pane>
        <el-tab-pane
          label="内部定额表"
          name="second"
          style="text-align: left"
          class="firstTab1"
          v-else-if="dialogForm.type != 'MATERIAL'"
        >
          <QuotaList
            @saveChoiceItems="saveChoiceItems"
            :contractType="dialogForm.type"
            @setDecimalShow="setDecimalShow"
            :engineerItems="dialogForm.subContractQuotaDetailsVOs"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></QuotaList>
        </el-tab-pane>
        <el-tab-pane
          label="物资清单"
          name="second2"
          style="text-align: left"
          v-else
          class="firstTab1"
        >
          <GoodList
            @saveGoodItems="saveGoodItems"
            @setDecimalShow="setDecimalShow"
            :goodItems="dialogForm.subContractMaterialDetailsVOs"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></GoodList>
        </el-tab-pane>
        <!-- <el-tab-pane
          label="生成合同"
          name="third"
          style="text-align:left;width: 60%"
        >
          <CombinedContract :dialogForm="dialogForm"></CombinedContract>
        </el-tab-pane> -->
        <el-tab-pane
          label="生成合同"
          name="ten"
          style="text-align: left; width: 60%"
          v-if="contractFlag"
        >
          <el-button
            type="info"
            @click="choiceTemplate"
            style="position: fixed; left: 600px; top: 101px; z-index: 10"
            >选择合同模板</el-button
          >
          <component
            :is="comName"
            ref="comName"
            :templateKey="templateKey"
            :dialogForm="dialogForm"
            :subServiceContractId="subServiceContractId || 0"
            @savePrintInfo="savePrintInfo"
          ></component>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <div v-if="dialogForm.purchaseType != 'directBuy'">
            <div class="Contractfile">会议纪要</div>

            <upLoadFileDialog
              :itemVOs="dialogForm.conferenceItemVOs"
              @saveUpdateFile="saveConferenceUpdateFile"
            ></upLoadFileDialog>
          </div>
          <div>
            <div class="Contractfile" style="margin-top: 24px">其他附件</div>
            <upLoadFileDialog
              :itemVOs="dialogForm.contractItemVOs"
              @saveUpdateFile="saveUpdateFile"
            ></upLoadFileDialog>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left; width: 90%; margin-top: 20px"
        >
          <ContractApproveLine
            :addoredit="editFlag"
            :itemId="subServiceContractId || 0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="dialogForm.approveTemplateType || dialogForm.type"
            :subApproveName="dialogForm.approveTemplateName || ''"
          ></ContractApproveLine>
        </el-tab-pane>
        <el-tab-pane
          label="补充协议"
          name="sixth"
          style="text-align: left; width: 80%"
          v-if="dialogForm.appendSubContracts.length > 0"
        >
          <addContractProtocol
            :contractScanVOs="dialogForm.appendSubContracts"
            :subServiceContractId="subServiceContractId"
          ></addContractProtocol>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="CombinedContract" v-if="!contractFlag"
        >生成合同</el-button
      >
      <el-button type="primary" @click="saveServicesContractInfo(true)"
        >暂 存</el-button
      >
      <el-button type="primary" @click="saveServicesContractInfo(false)"
        >提 交</el-button
      >
      <el-button type="info" @click="close">取 消</el-button>
      <div class="contractTip" v-if="contractFlag && activeName == 'ten'">
        生成合同内容通过顶部保存按钮单独保存
      </div>
    </div>

    <!-- 选择申请人弹窗弹框 -->
    <ApplyUserDialog
      @dialogClose="applyUserDiaVisible = false"
      @SaveApplyUser="saveApplyUser"
      @close="closeDialog"
      :applyUserName="dialogForm.applyUserName"
      :applyUserDiaVisible="applyUserDiaVisible"
    ></ApplyUserDialog>
    <!--设置合同模板弹窗-->
    <setTemplate
      :contractType="dialogForm.type"
      @saveTemplateFun="saveTemplateFun"
      ref="setTemplateType"
    ></setTemplate>
    <!--设置位数弹窗-->
    <setDecimal
      @saveDecimalFun="saveDecimalFun"
      ref="setDecimalref"
    ></setDecimal>
  </div>
</template>

<script>
import {
  getContractCodeByUserCodeService, //获取下拉列表数据
  saveServiceContractServices, //新增一条劳务合同信息
  updateServiceContractInfoServices, //更新一条劳务合同信息
  getServiceContractDetailService, //获取一条劳务合同信息
  getBasicDataListService,
  getDefaultDetailsServices, //分项合同-获取分项合同默认细目
} from "@/services/allContractServices";
import {
  getBidTypeDic, //获取一级数据字典接口
} from "@/services/bidServices";
import {
  getOrgIdService, //根据用户id获取组织id
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import {
  getValidSupplierAList, //获取有效供应商列表接口 aType：甲方，bType：乙方
} from "../../../services/supplierMagServices";
import {
  saveApproveFun,
  updateApproveFun,
} from "@/page/approveComponents/approve";
import { numFilter } from "@/utils/filters";
import QuotaList from "./QuotaList"; //机械、其他合同内部定额表tab页
import itemList from "./itemList"; //劳务合同内部定额表tab页
import setDecimal from "./coms/setDecimalDialog.vue"; //其他合同默认模板

import GoodList from "./GoodList"; //采购合同物资清单tab页
import ContractApproveLine from "../../approveComponents/NewApproveLine"; //新增审批流程
import ApplyUserDialog from "../commonCell/ApplyUserDialog"; //选择申请人弹窗
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import addContractProtocol from "./addContractProtocol"; //补充协议列表

import setTemplate from "../template/setTemplateDialog"; //其他合同默认模板

import LaborContract from "../template/LaborContract"; //劳务合同 A
import MaterialProcurementContract from "../template/MaterialProcurementContract"; //B 物资采购合同 单价
import MaterialProcurementTotalContract from "../template/MaterialProcurementTotalContract"; //C 物资采购合同 总价
import CarriageContract from "../template/CarriageContract"; //D运输合同
import mudMixContract from "../template/machine/mudMixContract"; //稳定土拌合加工合同
import asphaltMixContract from "../template/machine/asphaltMixContract"; //沥青拌合加工合同
import machinLeaseContract from "../template/machine/machinLeaseContract"; //机械租赁合同
import concretMixContract from "../template/machine/concretMixContract"; //混凝土拌合加工运输合
import transportContract from "../template/machine/transportContract"; //拌合料运输合同
import transportbhlContract from "../template/machine/transportbhlContract"; //运输合同—适用于各种拌合料
import concreteMakeMixContract from "../template/machine/concreteMakeMixContract"; //混凝土拌合加工合同

import noTemplate from "../template/noTemplate"; //其他合同无合同模板
import carRentalContract from "../template/carRentalContract"; //其他合同-汽车租赁合同模板

// import CombinedContract from "../template/CombinedContract1"; //生成合同CombinedContract
export default {
  name: "AddServiceContract",
  flag: false, //是否保存过审批流
  components: {
    addContractProtocol, //追加补充协议列表
    GoodList,
    QuotaList,
    itemList,
    setDecimal,
    // CombinedContract, //打印劳务合同
    // buyCombinedContract, //打印物资采购
    ApplyUserDialog, //选择申请人组件
    upLoadFileDialog, //上传附件
    ContractApproveLine, //审批流程
    setTemplate, //设置合同模板
    LaborContract, // A劳务合同
    MaterialProcurementContract, // B 物资采购合同 单价
    MaterialProcurementTotalContract, // C 物资采购合同 总价
    CarriageContract, //  D运输合同
    mudMixContract, //稳定土拌合加工合同
    machinLeaseContract, //机械租赁合同
    transportContract, //拌合料运输合同
    asphaltMixContract, //沥青拌合加工合同
    concretMixContract, //混凝土拌合加工运输合同
    carRentalContract, //汽车租赁合同模板
    // otherLaborContract, //其他合同添加劳务合同模板
    transportbhlContract,
    concreteMakeMixContract,
    noTemplate,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      templateKey: "new",
      approveType: "subContract", //审批流类型
      approveClass: "SUB_CONTRACT",
      editFlag: false, //false：新建 true：编辑
      addFlag: false, //true:追加补充协议
      ProjectNameList: [], //所属项目下拉框
      category: "PROJECT_NAME", //下拉列表类型，默认为项目名称
      FinanceClassifyList: [], //财务分类下拉列表
      EngineerClassifyList: [], //工程分类下拉列表
      FinanceList: [], //财务一级下拉列表
      subDeptList: [], //部门列表
      typeOption: [], //采购方式下拉列表数据
      applyUserDiaVisible: false, //选择申请人弹窗
      subServiceContractId: "", //存储获取劳务合同id
      RouteParam: {}, //存储路由跳转参数
      checkedone: false,
      checkedtwo: false,
      checkedthree: false,
      SupplierAList: [], //甲方供应商列表
      SupplierList: [], //乙方供应商列表
      contractFlag: false,
      templateFlag: false, //模板弹窗可见性
      templateType: "",
      comName: "", //组件名称
      comNameType: "", //物资清单内部定额表组件类型
      otherPartyBIds: [], //其它相关方
      dialogForm: {
        id: 0,
        pcontractId: 0, //如果是补充协议，存储分项合同id
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        advancePayPct: "", //预付款比例
        advancePayPctAct: "", //付款比例
        amountTax: "", //税金计算值
        amountTaxShow: "", //税金显示值
        amountWithoutTax: "", //除税合同金额
        amountWithoutTaxShow: "", //除税合同金额
        applyDeptId: "", //申请人部门ID
        applyDeptName: "", //申请人部门名称
        applyUserId: "", //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: "", //审批状态编码
        approveStatusName: "", //审批状态名称
        approveUserId: "", //当前审批人
        signDate: "", //签订日期
        signPlace: "", //签订地点
        amount: undefined, //合同金额计算值
        amountShow: undefined, //合同金额显示值
        comments: "", //备注
        agreeOn: "", //付款约定
        content: "", //合同内容
        contractPeriodArr: [], //合同期限
        otherPartyBList: [],
        predictAmount: "", //单价合同预估数量
        predictPrice: "", //单价合同预估金额
        priceType: "0", //1单价合同 2总价合同
        isAdvancePay: 0, //是否预付款
        projectId: "", //所属项目id
        projectName: "", //所属项目名称
        taxRate: "", //税率
        totalAmount: "", //总价合同总金额
        type: "LABOR", //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
        updateTime: "",
        copies: "", //合同份数
        contractItemVOs: [],
        subContractMaterialDetailsVOs: [], //物资采购合同 物资明细列表
        subContractUnionDetailsVOList: [], //物资清单和内部定额表合并对象
        // subContractProjectDetailsVOs: [], //工程量清单
        appendSubContracts: [], //追加协议列表
        contractScanVOs: [], //合同扫描件
        purchaseType: "", //采购方式 20220112
        subContractQuotaDetailsVOs: [], //内部定额表 20220112
        conferenceItemVOs: [], //会议纪要附件列表 20220112
        subContractPrintVO: {}, //合同模板打印信息
        pointSettingDto: {
          totalPurePrice: 2,
          totalPriceAfterTax: 2,
        }, //设置字段小数位数
        isTempSave: "", //是否暂存标识
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      rules: {
        type: [{ required: true, message: "请选择合同分类", trigger: "blur" }],
        serialNumber: [
          { required: true, message: "请填写合同编码", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请填写合同名称", trigger: "blur" },
          {
            min: 1,
            max: 60,
            message: "长度在 1 到 60 个字符",
            trigger: "blur",
          },
        ],

        partyAId: [
          { required: true, message: "请选择合同甲方", trigger: "change" },
        ],
        partyBId: [
          { required: true, message: "请选择合同乙方", trigger: "change" },
        ],

        purchaseType: [
          { required: true, message: "请选择采购方式", trigger: "change" },
        ],

        amount: [
          { required: true, message: "请填写合同金额", trigger: "blur" },
          {
            min: 1,
            max: 14,
            message: "最长输入14位数字",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请填写合同内容", trigger: "blur" },
        ],
        projectId: [
          { required: true, message: "请选择所属项目", trigger: "change" },
        ],
        signDate: [
          {
            type: "date",
            required: true,
            message: "请填写签订日期",
            trigger: "blur",
          },
        ],
        amountWithoutTax: [
          { required: true, message: "请填写除税合同金额", trigger: "blur" },
        ],
        taxRate: [{ required: true, message: "请填写税率", trigger: "blur" }],
        amountTax: [
          { required: true, message: "请填写税金", trigger: "blur" },
          // , {
          //     min: 1,
          //     max: 20,
          //     message: "最长输入20位数字",
          //     trigger: "blur"
          //   }
          //  ,{
          //   pattern: /^[0-9,.]+$/,
          //   message: "只能输入数字",
          //   trigger: "change"
          // }
        ],
        contractPeriodArr: [
          { required: true, message: "请填写合同期限", trigger: "blur" },
        ],
        copies: [
          { required: true, message: "请填写合同份数", trigger: "blur" },
        ],
        agreeOn: [
          { required: true, message: "请填写合同重要约定", trigger: "blur" },
        ],
        comments: [{ required: true, message: "请填写备注", trigger: "blur" }],
        applyUserName: [
          { required: true, message: "请填写申请人", trigger: "blur" },
        ],
        applyDeptId: [
          { required: true, message: "请填写申请部门", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.dialogForm.applyUserName = sessionStorage.getItem("name");
    this.dialogForm.applyDeptId = sessionStorage.getItem("deptId");
    this.dialogForm.applyUserId = sessionStorage.getItem("currentUserId");
    this.getProjectCode(this.category); //获取项目名称下拉框数据
    this.getProjectClubList(0); //获取部门一级下拉列表
    this.getapplyDeptName(); //获取部门名称
    this.getSupplierList(); // 获取所有乙方供应商列表
    this.getSupplierAList(); //获取所有甲方供应商列表
    this.getbidPlanType(); //获取采购方式下拉列表
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 60;
    try {
      document.getElementsByClassName("AddServiceContract")[0].style.height =
        ch + "px";
    } catch (error) {
      console.log("-- tableHeight error\n", error);
    }

    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 60;
        document.getElementsByClassName("AddServiceContract")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.templateKey += 1;
      console.log(this.templateKey);
      this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
      this.dialogForm.type = this.tabRouteParam.type;
      this.dialogForm.subContractMaterialDetailsVOs = []; //清空材料合同物资清单数据
      this.dialogForm.subContractUnionDetailsVOList = []; //清空劳务数据
      this.dialogForm.subContractQuotaDetailsVOs = []; //清空内部定额表数据
      this.otherPartyBIds = [];
      this.dialogForm.otherPartyBList = []; //清空其它相对方数据

      if (this.editFlag) {
        this.contractFlag = true;
        //编辑 获取一条分项合同信息
        this.subServiceContractId = this.tabRouteParam.id;
        this.getsubServiceContractDetail(this.subServiceContractId);
        // if (this.tabRouteParam.addFlag == 2) {
        //   //编辑追加协议
        //   this.addFlag = true;
        //   this.subServiceContractId = this.tabRouteParam.id; //存储补充协议id
        //   this.dialogForm.pcontractId = this.tabRouteParam.pid;
        // }
      } else {
        if (this.tabRouteParam.addFlag == 1) {
          //补充追加协议
          this.addFlag = true;
          // this.subServiceContractId = this.tabRouteParam.id;
          this.dialogForm.pcontractId = this.tabRouteParam.id;
        }
      }
    },
    //tab页切换
    handleTabClick(tab, event) {
      switch (this.activeName) {
        case "seven":
          break;
        case "second2":
          // this.getDefaultDetailsList();
          break;
        default:
          // this.Contractform.tabIndex = "0";
          break;
      }
    },

    handleTabLeave(toTab, fromTab) {
      switch (fromTab) {
        case "seven":
          // this.$confirm('是否保存合同模板内容？', "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "info",
          // })
          //   .then(() => {
          //    this.$refs.LaborContract.saveContractA()
          //   })
          //   .catch(() => {});
          this.$refs.LaborContract.saveContractA();
          break;
        case "eight":
          //  this.$confirm('是否保存合同模板内容？', "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "info",
          // })
          //   .then(() => {
          //    this.$refs.MaterialProcurementContract.saveContractA()
          //   })
          //   .catch(() => {});
          this.$refs.MaterialProcurementContract.saveContractA();
          break;
        case "nine":
          // this.$confirm('是否保存合同模板内容？', "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "info",
          // })
          //   .then(() => {
          //    this.$refs.materialProcureContract.saveContractA()
          //   })
          //   .catch(() => {});
          this.$refs.materialProcureContract.saveContractA();
          break;
        case "ten":
          //  this.$confirm('是否保存合同模板内容？', "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "info",
          // })
          //   .then(() => {
          //    this.$refs.carriageContract.saveContractA()
          //   })
          //   .catch(() => {});
          this.$refs.carriageContract.saveContractA();
          break;
        default:
          // this.Contractform.tabIndex = "0";
          break;
      }
    },

    getDefaultDetailsList() {
      if (this.dialogForm.partyBId && this.dialogForm.projectId) {
        let reqParam = {
          partyBId: this.dialogForm.partyBId, //分项合同合同甲方获取乙方供应商列表
          projectId: this.dialogForm.projectId,
          subContractTypeEnum: this.dialogForm.type,
        };
        getDefaultDetailsServices(reqParam)
          .then((res) => {
            if (res.code == 10000000) {
              if (this.dialogForm.type == "MATERIAL") {
                let data = res.data.materialList || [];
                for (let i = 0; i < data.length; i++) {
                  if (!data[i].bidPrice) {
                    data[i].dictId = data[i].id;
                    data[i].quantity = 0;
                    data[i].isEdit = false;
                    data[i].taxRate = 0; //税率
                    data[i].bidPrice = 0; //data[i].unitPrice; //中标裸税单价 中标裸税单价=单价/(1+税率)
                    data[i].totalPurePrice = 0; //裸税合价
                  }
                }
                this.dialogForm.subContractMaterialDetailsVOs = data;
              } else if (this.dialogForm.type == "LABOR") {
                let data = res.data.unionList || [];
                for (let i = 0; i < data.length; i++) {
                  if (!data[i].bidPrice) {
                    data[i].dictId = data[i].id;
                    data[i].quantity = 0;
                    data[i].isEdit = false;
                    data[i].taxRate = 0; //税率
                    data[i].bidPrice = 0; //data[i].unitPrice; //中标裸税单价 中标裸税单价=单价/(1+税率)
                    data[i].totalPurePrice = 0; //裸税合价
                  }
                }
                this.dialogForm.subContractUnionDetailsVOList = data;
              } else {
                let data = res.data.commonList || [];
                for (let i = 0; i < data.length; i++) {
                  if (!data[i].bidPrice) {
                    data[i].dictId = data[i].id;
                    data[i].quantity = 0;
                    data[i].taxRate = 0; //税率
                    data[i].synthesizePriceAfterTax = 0; //税后综合单价
                    data[i].totalPurePrice = 0; //裸税合价
                    data[i].totalPriceAfterTax = 0; //税后合价
                    data[i].totalPrice = 0; //金额
                    data[i].bidPrice = 0;
                    data[i].isEdit = false;
                    // if (this.contractType === "LABOR") {
                    //   data[i].bidPrice = data[i].guideLaborPrice; //中标裸税单价默认=指导劳务单价
                    // } else {
                    //   data[i].bidPrice = data[i].materialPrice;
                    // }
                  }
                }
                this.dialogForm.subContractQuotaDetailsVOs = data;
              }
            } else {
              if (res.code > 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch(() => {});
      }
    },

    //甲方下拉列表中，展示的内容为乙方供应商数据，路桥作为乙方供应商数据维护，并置顶显示
    getSupplierAList() {
      let reqParam = {
        topType: "bType", //分项合同合同甲方获取乙方供应商列表
        pageIndex: 1,
        pageSize: -1,
      };
      getValidSupplierAList(reqParam)
        .then((res) => {
          if (res.code == 10000000) {
            this.SupplierAList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //获取所有乙方供应商列表
    getSupplierList() {
      let reqParam = {
        topType: "bType", //乙方供应商
        pageIndex: 1,
        pageSize: -1,
      };
      getValidSupplierAList(reqParam)
        .then((res) => {
          if (res.code == 10000000) {
            this.SupplierList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    //项目部名称
    handleProjectChange(value) {
      let obj = {};
      obj = this.ProjectNameList.find((item) => {
        return item.id == value; //筛选出匹配数据
      });
      this.dialogForm.projectName = obj.name;
      if (this.dialogForm.partyBId && !this.editFlag) {
        this.getDefaultDetailsList();
      }
    },
    //生成合同
    CombinedContract() {
      this.$refs["ruleForm"].validate((valid) => {
        if (this.dialogForm.type == "MATERIAL") {
          //材料合同 单价合同总价合同限制必选一个
          if (!this.checkedtwo && !this.checkedthree) {
            this.$alert("请选择单价合同或总价合同", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
        if (this.checkedone) {
          this.dialogForm.isAdvancePay = 1;
          if (this.dialogForm.advancePayPct == "") {
            this.$alert("请输入预付款比例", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.dialogForm.advancePayPctAct == "") {
            this.$alert("请输入付款比例", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else {
          this.dialogForm.isAdvancePay = 0;
          this.dialogForm.advancePayPct = "";
          this.dialogForm.advancePayPctAct = "";
        }
        if (this.checkedtwo) {
          this.dialogForm.priceType = 1;
          if (this.dialogForm.predictPrice == "") {
            this.$alert("请输入预估合同金额", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.dialogForm.predictAmount == "") {
            this.$alert("请输入预估合同数量", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else if (this.checkedthree) {
          this.dialogForm.priceType = 2;
          if (this.dialogForm.totalAmount == "") {
            this.$alert("请输入合同金额", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else {
          this.dialogForm.priceType = 0;
          this.dialogForm.predictPrice = "";
          this.dialogForm.predictAmount = "";
          this.dialogForm.totalAmount = "";
        }
        if (valid) {
          if (this.dialogForm.type == "MATERIAL"&&!this.dialogForm.signDate) {
            this.$confirm(
              "尚未录入签订日期，请完善信息或自行录入合同模板中的签订日期",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info",
              }
            )
              .then(() => {
                this.saveTemplateFun();
                this.contractFlag = true;
              })
              .catch(() => {});
          }else{
            this.saveTemplateFun();
            this.contractFlag = true;
          }
        } else {
          this.$alert("请完整录入合同基础信息", "提示", {
            confirmButtonText: "确定",
          });
        }
      });
    },
    // 提交合同基本信息
    saveServicesContractInfo(val) {
      this.$refs["ruleForm"].validate((valid) => {
        //val=true 暂存 false：提交

        if (this.dialogForm.type == "MATERIAL") {
          //材料合同 单价合同总价合同限制必选一个
          if (!this.checkedtwo && !this.checkedthree) {
            this.$alert("请选择单价合同或总价合同", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
        if (this.checkedone) {
          this.dialogForm.isAdvancePay = 1;
          if (this.dialogForm.advancePayPct == "") {
            this.$alert("请输入预付款比例", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.dialogForm.advancePayPctAct == "") {
            this.$alert("请输入付款比例", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else {
          this.dialogForm.isAdvancePay = 0;
          this.dialogForm.advancePayPct == "";
          this.dialogForm.advancePayPctAct == "";
        }
        if (this.checkedtwo) {
          this.dialogForm.priceType = 1;
          if (this.dialogForm.predictPrice === "") {
            this.$alert("请输入预估合同金额", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.dialogForm.predictAmount === "") {
            this.$alert("请输入预估合同数量", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else if (this.checkedthree) {
          this.dialogForm.priceType = 2;
          if (this.dialogForm.totalAmount === "") {
            this.$alert("请输入合同金额", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else {
          this.dialogForm.priceType = 0;
          this.dialogForm.predictPrice = "";
          this.dialogForm.predictAmount = "";
          this.dialogForm.totalAmount = "";
        }
        this.dialogForm.contractPeriodStart =
          this.dialogForm.contractPeriodArr[0];
        this.dialogForm.contractPeriod = this.dialogForm.contractPeriodArr[1];

        if (valid) {
          if (this.otherPartyBIds && this.otherPartyBIds.length > 0) {
            this.dialogForm.otherPartyBList = this.otherPartyBIds.map((em) => {
              let obj = {};
              obj.partyB = this.SupplierList.find(
                (item) => item.id == em
              ).companyName;
              obj.partyBId = em;
              return obj;
            });
          }
          this.dialogForm.isTempSave = val;
          if (val) {
            this.tempSaveContent();
            return;
          }
          if (this.dialogForm.taxRate > 100) {
            this.$alert("税率应该小于等于100", "提示", {
              confirmButtonText: "确定",
            });
            return;
          } else if (this.dialogForm.advancePayPct > 100) {
            this.$alert("预付款比例应该小于等于100", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.dialogForm.advancePayPctAct > 100) {
            this.$alert("付款比例应该小于等于100", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.approveParams.approveProcessDtoList.length < 1) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              // this.$alert(
              //   this.approveParams.approveProcessDtoList[i].jobName +
              //     " 节点未选择审批人员",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //   }
              // );
              this.$alert("未选择审批人员", "提示", {
                confirmButtonText: "确定",
              });
              return;
            }
          }
          let msg = "您确定提交分项合同吗, 是否继续?";
          if (this.dialogForm.type == "LABOR") {
            msg = "您确定提交劳务分项合同吗, 是否继续?";
          } else if (this.dialogForm.type == "MATERIAL") {
            msg = "您确定提交材料分项合同吗, 是否继续?";
          } else if (this.dialogForm.type == "MACHINE") {
            msg = "您确定提交机械分项合同吗, 是否继续?";
          } else {
            msg = "您确定提交分项合同吗, 是否继续?";
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      // let data = { ...this.dialogForm };
      let param = {};

      this.dialogForm.amount = this.dialogForm.amount.replace(/,/g, "");
      this.dialogForm.amountWithoutTax =
        this.dialogForm.amountWithoutTax.replace(/,/g, "");
      if (this.dialogForm.amountTax != 0) {
        this.dialogForm.amountTax = this.dialogForm.amountTax.replace(/,/g, "");
      }

      if (
        this.dialogForm.predictPrice != "" &&
        undefined != this.dialogForm.predictPrice
      ) {
        this.dialogForm.predictPrice = this.dialogForm.predictPrice.replace(
          /,/g,
          ""
        );
      }
      if (
        this.dialogForm.totalAmount != "" &&
        undefined != this.dialogForm.totalAmount
      ) {
        this.dialogForm.totalAmount = this.dialogForm.totalAmount.replace(
          /,/g,
          ""
        );
      }
      param = { ...this.dialogForm };

      if (!this.editFlag) {
        //新增劳务合同
        saveServiceContractServices(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(res.data);
            } else if (res.code >= 20000000) {
              this.Fornmat(0);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.Fornmat(0);
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新劳务合同
        param.id = this.subServiceContractId;
        updateServiceContractInfoServices(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(this.subServiceContractId);
            } else if (res.code >= 20000000) {
              this.Fornmat(0);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.Fornmat(0);
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    tempSaveContent() {
      // let data = { ...this.dialogForm };
      let param = {};

      this.dialogForm.amount = this.dialogForm.amount?.replace(/,/g, "") ?? "";
      this.dialogForm.amountWithoutTax =
        this.dialogForm.amountWithoutTax?.replace(/,/g, "") ?? "";
      if (this.dialogForm.amountTax != 0) {
        this.dialogForm.amountTax =
          this.dialogForm.amountTax?.replace(/,/g, "") ?? "";
      }

      if (
        this.dialogForm.predictPrice != "" &&
        undefined != this.dialogForm.predictPrice
      ) {
        this.dialogForm.predictPrice = this.dialogForm.predictPrice.replace(
          /,/g,
          ""
        );
      }
      if (
        this.dialogForm.totalAmount != "" &&
        undefined != this.dialogForm.totalAmount
      ) {
        this.dialogForm.totalAmount = this.dialogForm.totalAmount.replace(
          /,/g,
          ""
        );
      }
      if (this.dialogForm.approveTemplateType) {
        //撤回状态的合同暂存的时候保存审批流
        if (this.approveParams.approveProcessDtoList.length < 1) {
          this.$alert(" 未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        for (
          let i = 0;
          i < this.approveParams.approveProcessDtoList.length;
          i++
        ) {
          delete this.approveParams.approveProcessDtoList[i].type;
          if (
            this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
            null == this.approveParams.approveProcessDtoList[i].approveUserId
          ) {
            this.$alert("未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
      }
      param = { ...this.dialogForm };

      if (!this.editFlag) {
        //新增劳务合同
        saveServiceContractServices(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              //保存审批流
              if (this.dialogForm.approveTemplateType) {
                await this.saveTempApproveFun(res.data);
              } else {
                this.$message.success("暂存成功");
              }
              this.close();
              this.clearDialogForm();
            } else if (res.code >= 20000000) {
              this.Fornmat(0);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.Fornmat(0);
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新劳务合同
        param.id = this.subServiceContractId;
        updateServiceContractInfoServices(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              // this.$message.success("暂存成功");
              //保存审批流
              if (this.dialogForm.approveTemplateType) {
                await this.saveTempApproveFun(this.subServiceContractId);
              } else {
                this.$message.success("暂存成功");
              }
              this.close();
            } else if (res.code >= 20000000) {
              this.Fornmat(0);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.Fornmat(0);
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //打开设置小数弹窗
    setDecimalShow() {
      this.$refs.setDecimalref.showDialog(
        this.dialogForm.type,
        this.dialogForm.pointSettingDto
      );
    },
    saveDecimalFun(val) {
      this.dialogForm.pointSettingDto = val;
    },

    //创建审批流函数
    async saveApproveFun(contractId) {
      this.approveParams.itemId = contractId;
      this.approveParams.projectId = this.dialogForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "SUB_CONTRACT";
      let subType = "";
      switch (this.dialogForm.type) {
        case "LABOR":
          subType = "劳务";
          break;
        case "MATERIAL":
          subType = "材料";
          break;
        case "MACHINE":
          subType = "机械";
          break;
        case "OTHERS":
          subType = "其它";
          break;
      }
      this.approveParams.itemName = `${this.dialogForm.applyUserName}关于 ${this.dialogForm.partyB} 分项合同 ${this.dialogForm.name} 编号 ${this.dialogForm.serialNumber} 的 ${subType}分项合同申请`;
      let apiName = this.flag ? updateApproveFun : saveApproveFun;
      let res = await apiName(this.approveParams);
      if (res.code == 10000000) {
        this.close();
      } else {
        this.$message.error(res.msg);
      }
    },
    //暂存保存审批流
    async saveTempApproveFun(contractId) {
      this.approveParams.itemId = contractId;
      this.approveParams.projectId = this.dialogForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "READY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "SUB_CONTRACT";
      let subType = "";
      switch (this.dialogForm.type) {
        case "LABOR":
          subType = "劳务";
          break;
        case "MATERIAL":
          subType = "材料";
          break;
        case "MACHINE":
          subType = "机械";
          break;
        case "OTHERS":
          subType = "其它";
          break;
      }
      this.approveParams.itemName = `${this.dialogForm.applyUserName}关于 ${this.dialogForm.partyB} 分项合同 ${this.dialogForm.name} 编号 ${this.dialogForm.serialNumber} 的 ${subType}分项合同申请`;
      let res = await saveApproveFun(this.approveParams);
      if (res.code == 10000000) {
        this.$message.success("暂存成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    clearDialogForm() {
      this.dialogForm = {
        id: 0,
        pcontractId: 0, //如果是补充协议，存储分项合同id
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        otherPartyBList: [],
        advancePayPct: "", //预付款比例
        advancePayPctAct: "", //付款比例
        amountTax: "", //税金
        amountWithoutTax: "", //除税合同金额
        amountWithoutTaxShow: "", //除税合同金额
        applyDeptId: "", //申请人部门ID
        applyDeptName: "", //申请人部门名称
        applyUserId: "", //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: "", //审批状态编码
        approveStatusName: "", //审批状态名称
        approveUserId: "", //当前审批人
        signDate: "", //签订日期
        signPlace: "", //签订地点
        amount: "", //合同金额
        comments: "", //备注
        agreeOn: "", //付款约定
        content: "", //合同内容
        contractPeriodArr: [], //合同期限
        predictAmount: "", //单价合同预估数量
        predictPrice: "", //单价合同预估金额
        priceType: "0", //1单价合同 2总价合同
        isAdvancePay: 0, //是否预付款
        projectId: "", //所属项目id
        projectName: "", //所属项目名称
        taxRate: "", //税率
        totalAmount: "", //总价合同总金额
        type: "LABOR", //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
        updateTime: "",
        copies: "", //合同份数
        decimal1: 2,
        decimal2: 2,
        contractItemVOs: [],
        subContractMaterialDetailsVOs: [], //物资采购合同 物资明细列表
        subContractUnionDetailsVOList: [], //物资内部定额表合并清单
        // subContractProjectDetailsVOs: [], //工程量清单
        appendSubContracts: [], //追加协议列表
        contractScanVOs: [], //合同扫描件
        purchaseType: "", //采购方式 20220112
        subContractQuotaDetailsVOs: [], //内部定额表 20220112
        conferenceItemVOs: [], //会议纪要附件列表 20220112
      };
    },
    close() {
      if (this.addFlag) {
        this.bus.$emit("tabClose", "approveDetail");
      } else if (this.dialogForm.pcontractId) {
        this.bus.$emit("tabClose", "innerApproveDetail");
      } else if (!this.editFlag) {
        this.bus.$emit("tabClose", "modQuestionnaire");
      } else {
        this.bus.$emit("tabClose", "roomBindingSta");
      }
      if (this.dialogForm.type == "LABOR") {
        //1 劳务 2采购 3其他
        this.bus.$emit("navMenuChange", {
          routeId: "payment-orderCheck",
        });
      } else if (this.dialogForm.type == "MATERIAL") {
        this.bus.$emit("navMenuChange", {
          routeId: "buyContract",
        });
      } else if (this.dialogForm.type == "MACHINE") {
        this.bus.$emit("navMenuChange", {
          routeId: "machineryContractMag",
        });
      } else {
        this.bus.$emit("navMenuChange", {
          routeId: "otherContract",
        });
      }
      this.clearDialogForm();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (this.RouteParam) {
        let param = {};
        param.id = id;
        this.checkedone = false;
        this.checkedtwo = false;
        this.checkedthree = false;
        this.dialogForm.advancePayPct = "";
        this.dialogForm.advancePayPctAct = "";
        this.dialogForm.predictPrice = ""; //预估合同金额
        this.dialogForm.predictAmount = ""; //预估合同数量
        this.dialogForm.totalAmount = ""; //总价合同
        getServiceContractDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.dialogForm = { ...this.dialogForm, ...res.data };
              this.dialogForm.contractPeriodArr.push(
                this.dialogForm.contractPeriodStart || ""
              );
              this.dialogForm.contractPeriodArr.push(
                this.dialogForm.contractPeriod
              );
              // this.dialogForm = { this.dialogForm , ...res.data};
              this.Fornmat(0);
              // this.checkAmount(1)
              if (this.dialogForm.isAdvancePay == 1) {
                this.checkedone = true;
              }
              if (this.dialogForm.priceType == 1) {
                this.checkedtwo = true;
              } else if (this.dialogForm.priceType == 2) {
                this.checkedthree = true;
              } else {
                this.checkedtwo = false;
                this.checkedthree = false;
                this.dialogForm.predictPrice = "";
                this.dialogForm.predictAmount = "";
              }
              if (
                this.dialogForm.subContractPrintVO &&
                this.dialogForm.subContractPrintVO.templateType &&
                this.dialogForm.subContractPrintVO.templateType != "DEFAULT"
              ) {
                this.comName = this.dialogForm.subContractPrintVO.templateType;
              } else {
                this.saveTemplateFun();
              }

              this.dialogForm.contractItemVOs = res.data.contractItemVOs ?? [];

              if (
                res.data.conferenceItemVOs &&
                res.data.conferenceItemVOs.length
              ) {
                this.dialogForm.conferenceItemVOs = res.data.conferenceItemVOs;
              } else {
                this.dialogForm.conferenceItemVOs = [];
              }
              this.dialogForm.type = this.dialogForm.type.toString();
              this.dialogForm.projectId = this.dialogForm.projectId.toString();
              if (
                this.dialogForm.otherPartyBList &&
                this.dialogForm.otherPartyBList.length > 0
              ) {
                this.otherPartyBIds = this.dialogForm.otherPartyBList.map(
                  (em) => {
                    return em.partyBId;
                  }
                );
              }
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //获取部门名称
    getapplyDeptName() {
      //根据用户id去获取组织id
      let reqParam = {
        userId: this.dialogForm.applyUserId,
      };
      getOrgIdService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.dialogForm.applyDeptName = res.data.deptDisplayName;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.dialogForm.applyUserId = selectItems.applyUserId;
      this.dialogForm.applyUserName = selectItems.applyUserName;
      this.dialogForm.applyDeptId = selectItems.applyDeptId;
      this.dialogForm.applyDeptName = selectItems.applyDeptName;
      //  this.$set(this.dialogForm.applyUserName);
      this.applyUserDiaVisible = false;
    },
    //获取定额表、物资清单合同类型
    getcomNameType() {
      switch (this.dialogForm.type) {
        case "LABOR": //物资清单和内部定额表
          this.comNameType = "itemList";
          break;
        case "MATERIAL": //物资清单
          this.comNameType = "GoodList";
          break;
        case "MACHINE":
          this.comNameType = "QuotaList";
          break;
        case "OTHERS":
          this.comNameType = "QuotaList";
          break;
        default:
          this.comName = "QuotaList";
          break;
      }
    },
    //存储合同模板
    saveTemplateFun(templateType) {
      // this.templateType = type;
      //LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      switch (this.dialogForm.type) {
        case "LABOR":
          this.comName = "LaborContract";
          break;
        case "MATERIAL": //材料合同默认单价
          if (templateType && templateType != "DEFAULT")
            //总价
            this.comName = templateType;
          else if (this.dialogForm.priceType == 2) {
            this.comName = "MaterialProcurementTotalContract";
          } else {
            this.comName = "MaterialProcurementContract";
          }
          break;
        case "MACHINE":
          switch (templateType) {
            case "mudMixContract": //稳定土拌合加工合同
              this.comName = "mudMixContract";
              break;
            case "asphaltMixContract": //沥青拌合加工合同
              this.comName = "asphaltMixContract";
              break;
            case "concretMixContract": //混凝土拌合加工运输合同
              this.comName = "concretMixContract";
              break;
            case "machinLeaseContract": //机械租赁合同
              this.comName = "machinLeaseContract";
              break;
            case "transportContract": //拌合料运输合同
              this.comName = "transportContract";
              break;
            case "transportbhlContract": //运输合同—适用于各种拌合料
              this.comName = "transportbhlContract";
              break;
            case "concreteMakeMixContract": //混凝土拌合加工合同
              this.comName = "concreteMakeMixContract";
              break;
            default:
              // this.comName = "mudMixContract";
              this.comName = "carriageContract";
              break;
          }
          break;
        case "OTHERS":
          switch (templateType) {
            case "carRentalContract": //汽车租赁合同
              this.comName = "carRentalContract";
              break;
            case "noTemplate": //无合同模板
              this.comName = "noTemplate";
              break;
            case "mudMixContract": //稳定土拌合加工合同
              this.comName = "mudMixContract";
              break;
            case "asphaltMixContract": //沥青拌合加工合同
              this.comName = "asphaltMixContract";
              break;
            case "concretMixContract": //混凝土拌合加工运输合同
              this.comName = "concretMixContract";
              break;
            case "machinLeaseContract": //机械租赁合同
              this.comName = "machinLeaseContract";
              break;
            case "transportContract": //拌合料运输合同
              this.comName = "transportContract";
              break;
            case "transportbhlContract": //运输合同—适用于各种拌合料
              this.comName = "transportbhlContract";
              break;
            case "concreteMakeMixContract": //混凝土拌合加工合同
              this.comName = "concreteMakeMixContract";
              break;
            case "LaborContract":
              this.comName = "LaborContract";
              break;
            case "MaterialProcurementTotalContract": //总价合同
              this.comName = "MaterialProcurementTotalContract";
              break;
            case "MaterialProcurementContract": //单价合同
              this.comName = "MaterialProcurementContract";
              break;
            case "carriageContract": //运输合同
              this.comName = "carriageContract";
              break;
            default:
              // this.comName = "mudMixContract";
              this.comName = "LaborContract";
              break;
          }
      }
      if (!this.dialogForm.subContractPrintVO) {
        this.dialogForm.subContractPrintVO = {};
      }
      this.dialogForm.subContractPrintVO.templateType = this.comName;
    },

    //获取category下拉框数据
    getProjectCode(category) {
      let param = {};
      param.category = category;
      getContractCodeByUserCodeService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "PROJECT_NAME") {
              this.ProjectNameList = res.data; //项目名称
            } else if (category == "GENERAL_CONTRACT_NAME") {
              this.FinanceClassifyList = res.data; //财务分类
            } else {
              this.EngineerClassifyList = res.data; //工程分类
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //申请人对话框可见
    ShowApplyUserDia() {
      this.applyUserDiaVisible = true;
    },
    //数据改变时更新数据
    handleChange(value) {
      let len = value.length;
      this.dialogForm.applyDeptId = value[len - 1];
      this.dialogForm.applyDeptName = this.$refs["cascaderAddr"]
        .getCheckedNodes()[0]
        .pathLabels.join("/");
      //  let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
    },

    //保存内部定额表子目saveChoiceItems
    saveChoiceItems(selectItems) {
      this.dialogForm.subContractQuotaDetailsVOs = selectItems;
    },
    //保存物料清单
    saveGoodItems(selectItems) {
      this.dialogForm.subContractMaterialDetailsVOs = selectItems;
    },
    //保存物资和内部定额表合并
    saveUnionItems(selectItems) {
      let data = selectItems;
      data.forEach((item, index) => {
        item.sort = index + 1;
        return item;
      });
      this.dialogForm.subContractUnionDetailsVOList = data;
    },
    //存储会议纪要附件
    saveConferenceUpdateFile(selectItems) {
      this.dialogForm.conferenceItemVOs = selectItems;
    },
    //存储附件
    saveUpdateFile(selectItems) {
      this.dialogForm.contractItemVOs = selectItems;
      this.dialogForm.contractItemVOs.forEach((item) => {
        item.type = 1;
        return item;
      });
    },
    //存储审批流模板类型
    saveApproveType(item) {
      this.dialogForm.approveTemplateType = item.label;
      this.dialogForm.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems, flag = false) {
      this.flag = flag;
      this.approveParams.approveProcessDtoList = selectItems;
    },
    //存储合同模板打印信息
    savePrintInfo(printInfo) {
      if (printInfo.flag && printInfo.flag == 1) {
        this.dialogForm.subContractPrintVO =
          this.dialogForm?.subContractPrintVO ?? {};
        this.dialogForm.subContractPrintVO.content = printInfo.content;
        this.dialogForm.subContractPrintVO.version = printInfo.version;
        this.dialogForm.subContractPrintVO.templateType = this.comName; //存储合同模板
      } else if (printInfo.flag && printInfo.flag == 2) {
        this.dialogForm.subContractPrintVO =
          this.dialogForm?.subContractPrintVO ?? {};
        this.dialogForm.subContractPrintVO.watermark = printInfo.warterMark;
      }
    },
    //查看合同审批制度
    SeeApproveRule() {
      this.bus.$emit("navMenuChange", {
        routeId: "ContractApproveRule",
      });
    },
    handleCheckChange() {
      //复选框选择改变事件
      if (!this.checkedone) {
        this.dialogForm.advancePayPct = "";
        this.dialogForm.advancePayPctAct = "";
      }
      if (!this.checkedtwo) {
        this.dialogForm.predictPrice = "";
        this.dialogForm.predictAmount = "";
      } else {
        // this.dialogForm.amount = "0.00";
        // this.dialogForm.amountShow = "网价+150";
        // this.dialogForm.amountWithoutTax = "0.00";
        // this.dialogForm.amountWithoutTaxShow = "网价+150";
        // this.dialogForm.amountTax = "0.00";
        // this.dialogForm.amountTaxShow = "网价+150";
        if (this.checkedthree) {
          this.checkedthree = false;
          this.dialogForm.totalAmount = "";
        }
      }
    },
    handleCheckChange3() {
      //复选框选择改变事件
      if (!this.checkedthree) {
        this.dialogForm.totalAmount = "";
      } else {
        if (this.checkedtwo) {
          this.checkedtwo = false;
          this.dialogForm.predictPrice = "";
          this.dialogForm.predictAmount = "";
        }
      }
    },
    //校验税率在100以内，且只能输入数字
    checkValue(val) {
      if (val == 1) {
        this.dialogForm.taxRate = this.dialogForm.taxRate.replace(
          /^\D*(\d*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        if (this.dialogForm.taxRate > 100) {
          this.$alert("税率应该小于等于100", "提示", {
            confirmButtonText: "确定",
          });
          this.dialogForm.taxRate = "";
        }
      } else if (val == 2) {
        //预付款比例

        this.dialogForm.advancePayPct = this.dialogForm.advancePayPct.replace(
          /^\D*(\d*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        if (this.dialogForm.advancePayPct > 100) {
          this.$alert("预付款比例应该小于等于100", "提示", {
            confirmButtonText: "确定",
          });
          this.dialogForm.advancePayPct = "";
        }
      } else {
        this.dialogForm.advancePayPctAct =
          this.dialogForm.advancePayPctAct.replace(
            /^\D*(\d*(?:\.\d{0,2})?).*$/g,
            "$1"
          );
        if (this.dialogForm.advancePayPctAct > 100) {
          this.$alert("付款比例应该小于等于100", "提示", {
            confirmButtonText: "确定",
          });
          this.dialogForm.advancePayPctAct = "";
        }
      }
    },
    //格式化金额
    checkAmount(val) {
      if (val == 1) {
        //合同金额
        this.dialogForm.amount = (this.dialogForm.amount + "").replace(
          /^\D*([,\d]*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        //  numFilter(this.dialogForm.amount);
      } else if (val == 2) {
        //不含税价
        this.dialogForm.amountWithoutTax = (
          this.dialogForm.amountWithoutTax + ""
        ).replace(/^\D*([,\d]*(?:\.\d{0,2})?).*$/g, "$1");
      } else if (val == 3) {
        //税金
        this.dialogForm.amountTax = (this.dialogForm.amountTax + "").replace(
          /^\D*([,\d]*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
      } else if (val == 11) {
        //预估合同金额
        this.dialogForm.predictPrice = (
          this.dialogForm.predictPrice + ""
        ).replace(/^\D*([,\d]*(?:\.\d{0,2})?).*$/g, "$1");
      } else if (val == 12) {
        //总价合同金额
        this.dialogForm.totalAmount = (
          this.dialogForm.totalAmount + ""
        ).replace(/^\D*([,\d]*(?:\.\d{0,2})?).*$/g, "$1");
      }
    },
    //获取合同甲方名称名称
    ContractPartAChange(val) {
      let obj = {};
      obj = this.SupplierAList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.partyA = obj.companyName;
    },
    //获取合同乙方名称名称
    ContractPartBChange(val) {
      let obj = {};
      obj = this.SupplierList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.partyB = obj.companyName;
      if (this.dialogForm.projectId && !this.editFlag) {
        this.getDefaultDetailsList();
      }
    },
    Fornmat(val) {
      if (val == 1) {
        //合同金额
        if (this.dialogForm.amount) {
          this.dialogForm.amount = numFilter(this.dialogForm.amount);
        } else {
          this.dialogForm.amount = "0.00";
        }
        if (!this.dialogForm.amountShow)
          this.dialogForm.amountShow = this.dialogForm.amount;
      } else if (val == 2) {
        //不含税价
        if (this.dialogForm.amountWithoutTax) {
          this.dialogForm.amountWithoutTax = numFilter(
            this.dialogForm.amountWithoutTax
          );
        } else {
          this.dialogForm.amountWithoutTax = "0.00";
        }
        if (!this.dialogForm.amountWithoutTaxShow)
          this.dialogForm.amountWithoutTaxShow =
            this.dialogForm.amountWithoutTax;
      } else if (val == 3) {
        //税金
        if (this.dialogForm.amountTax)
          this.dialogForm.amountTax = numFilter(this.dialogForm.amountTax);
        else this.dialogForm.amountTax = "0.00";
        if (!this.dialogForm.amountTaxShow)
          this.dialogForm.amountTaxShow = this.dialogForm.amountTax;
      } else if (val == 11) {
        //预估合同金额
        this.dialogForm.predictPrice = numFilter(this.dialogForm.predictPrice);
      } else if (val == 12) {
        //总价合同金额
        this.dialogForm.totalAmount = numFilter(this.dialogForm.totalAmount);
      } else {
        if (this.dialogForm.amount) {
          this.dialogForm.amount = numFilter(this.dialogForm.amount);
        } else this.dialogForm.amount = "0.00";
        if (this.dialogForm.amountWithoutTax) {
          this.dialogForm.amountWithoutTax = numFilter(
            this.dialogForm.amountWithoutTax
          );
        } else this.dialogForm.amountWithoutTax = "0.00";

        if (this.dialogForm.amountTax) {
          this.dialogForm.amountTax = numFilter(this.dialogForm.amountTax);
        } else this.dialogForm.amountTax = "0.00";
        if (this.dialogForm.predictPrice) {
          this.dialogForm.predictPrice = numFilter(
            this.dialogForm.predictPrice
          );
        }
        if (this.dialogForm.totalAmount) {
          this.dialogForm.totalAmount = numFilter(this.dialogForm.totalAmount);
        }
      }
    },
    //选择合同模板弹窗
    choiceTemplate() {
      this.$refs.setTemplateType.showDialog(this.dialogForm.type, this.comName);
    },
    //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.AddServiceContract {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px;
        // margin-top: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 120px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
    .Contractfile {
      height: 44px;
      // padding-left: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
    }
  }

  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    .contractTip {
      float: right;
      color: red;
    }
  }
}

/deep/ .el-cascader .el-input__inner {
  &::placeholder {
    color: #606266;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #606266;
  }
}

/*.el-container {*/
/*    width: 100%;*/
/*    overflow: hidden;*/
/*}*/

.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

.screenPanel {
  text-align: left;
  height: auto;
}

.operatePanel {
  text-align: left;
  margin: 20px 60px;
}

.el-select {
  width: 100%;
}
.el-cascader {
  width: 100%;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 14px;
}

.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;

  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}

.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}

.right {
  height: 32px;
  line-height: 32px;
  width: 60px;
  text-align: center;
  cursor: pointer;
}

.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}

.el-select {
  margin-right: 10px;
}

/deep/ .el-date-editor--time {
  width: 130px;
}

/deep/ .el-container .el-main {
  height: auto;
}
.firstTab {
  width: 72%;
  margin-top: 20px;
}
.firstTab1 {
  width: 100%;
  margin-top: 20px;
}
@media only screen and(max-width:1610px) {
  .firstTab {
    width: 90%;
    margin-top: 20px;
  }
  .firstTab1 {
    width: 100%;
    margin-top: 20px;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
